import type { UploadTaskResult } from '@/hooks/uploads/createUploadTasks'

const getUploadedFileId = (
  result: UploadTaskResult | null | undefined
): string => {
  if (!result || !(result.status >= 200 && result.status < 300)) {
    throw new Error('File upload failed')
  }

  let body: unknown
  try {
    body = JSON.parse(result.body ?? '')
  } catch {
    throw new Error('Invalid upload response')
  }

  if (
    !body ||
    typeof body !== 'object' ||
    !('fileId' in body) ||
    typeof body.fileId !== 'string' ||
    !body.fileId.trim()
  ) {
    throw new Error('No fileId returned from upload')
  }

  return body.fileId
}

export default getUploadedFileId
